module.exports = __webpack_public_path__ + "static/media/davidOfMichelangelo.9137faee.jpg";